import { useSelector } from 'react-redux';
import { MoodboardState } from '../../../../../common/types/remoteConfig';
import { StateInterface } from '../../../../redux/types';
import { Config } from '../../../../../common/types/config';

export enum menuCheckKey {
    Moodboard = 'enableMoodboardEntry',
    OlapicUgcGallery = 'enableOlapicUgcGalleryEntry',
}

const useMenuItemChecks = (config: Config) => {
    const moodboard = useSelector<StateInterface, MoodboardState>(state => state.configurations.moodboard);
    const { enableMobileEntry } = moodboard;
    const { olapicUgcGallery } = config.links;

    return {
        [menuCheckKey.Moodboard]: enableMobileEntry,
        [menuCheckKey.OlapicUgcGallery]: !!olapicUgcGallery,
    };
};

export type MenuItemChecks = ReturnType<typeof useMenuItemChecks>;

export const isMenuItemEnabled = (checks: MenuItemChecks, checkKey?: menuCheckKey) => !checkKey || !!checks[checkKey];

export default useMenuItemChecks;
